import { useSdkWebsocketConnexion, WebSocketStatus } from "@kalyzee/kast-web-sdk";
import { useMemo, useRef } from "react";
import { Outlet } from "react-router-dom";
import ConnexionView from "../../../../components/utils/ConnexionView";
import { sdkClient } from "../../../../helpers/sdk";
import { useMode, useScreen } from "../../../../store/session/hooks";
import { SessionMode } from "../../../../store/session/slices";
import styles from "./private.module.css";

const PrivatePage = () => {
  const mode = useMode();
  const { socketStatus, retry } = useSdkWebsocketConnexion(sdkClient, mode === SessionMode.MASTER);
  const elementRef = useRef<HTMLDivElement>(null);
  const screen = useScreen();
  
  const status = useMemo(() => {
    return socketStatus === WebSocketStatus.Loading ? "connecting" : socketStatus === WebSocketStatus.Online ? "connected" : "disconnected";
  }, [socketStatus]);

  return (
    <div className={styles.mainContainer} ref={elementRef}>
      {screen !== undefined ? (
        <div style={{ position: "absolute", top: "10px", right: "10px", color: "black", fontSize: "26px", fontWeight: "bold" }}>{`${screen}`}</div>
      ) : null}
      { mode === SessionMode.MASTER && <ConnexionView
        status={status}
        retry={() => {
          retry();
        }}
      />}
      { mode !== SessionMode.MASTER || status === "connected" ? (
        <div className={styles.main}>
          <Outlet />
        </div>
      ) : null}
    </div>
  );
};

export default PrivatePage;
